import { useToggleState } from '@cian/react-utils';
import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { IReturnToRegularAdButtonProps } from './types';
import { AreaPartModal } from '../../modals/AreaPartModal/AreaPartModal';

export const ReturnToRegularAdButton: React.FC<IReturnToRegularAdButtonProps> = props => {
  const { onClick } = props;

  const { state: isModalOpened, toggle: toggleIsModalOpened } = useToggleState(false);

  return (
    <>
      <UIText2 color="primary_100" onClick={toggleIsModalOpened}>
        Вернуться к обычному объявлению
      </UIText2>

      <AreaPartModal
        opened={isModalOpened}
        heading="Создание обычного объявления"
        description="Если вернуться к созданию обычного объявления, то все данные для Мультиобъявления будут стёрты"
        approveButtonTitle="Стереть и вернуться"
        onApproveButtonClick={onClick}
        onClose={toggleIsModalOpened}
      />
    </>
  );
};
